import { render, staticRenderFns } from "./ShopifyFlowTemplates.vue?vue&type=template&id=d9d70d96&scoped=true"
import script from "./ShopifyFlowTemplates.vue?vue&type=script&lang=ts"
export * from "./ShopifyFlowTemplates.vue?vue&type=script&lang=ts"
import style0 from "./ShopifyFlowTemplates.vue?vue&type=style&index=0&id=d9d70d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d70d96",
  null
  
)

export default component.exports